import {createContext} from 'react'

const CatTipoOrdenCompraContext = createContext()

export default CatTipoOrdenCompraContext